<div class="timesheet-status-container">
    <div class="timesheet-status">
        <select
            [(ngModel)]="selectedStatus"
            [disabled]="!enableRecall"
            (change)="proposeRecall($event.target.value)"
            [ngClass]="selectedStatusClass">
            @for (status of availableStatuses; track status) {
                <option [ngValue]="status">
                    {{ ('timesheet.statuses.' + status.toLowerCase() + '.value') | translate }}
                </option>
            }
        </select>
    </div>

    <div class="week-sum-container">
        @if (loggedAccount.organisation.uuid !== ICITY_ORGANISATION_UUID && timesheetMode.USER === mode) {
            <button mat-mini-fab color="background" (click)="askSummary()">
                <mat-icon>functions</mat-icon>
            </button>
        }
    </div>
</div>
